module.exports = __webpack_public_path__ + "img/new_all.4e689614.svg";